import {createEntityAdapter} from '@reduxjs/toolkit'
import {IUser} from '../../types'

export const usersAdapter = createEntityAdapter<IUser>()